import theme from '../../../theme';

export const colorMap = {
    'red': theme.palette.error.main,
    'blue': theme.palette.additional.blue,
    'purple': theme.palette.additional.purple,
};